export const getLang = (locale: string): string | undefined => locale?.substring(0, 2);
